import type { Plan, AddonPackage, PaymentMethod, Invoice } from './types';

// 产品名称映射
export const productNameMap: Record<string, string> = {
  subtitle_basic: 'minuteExperiencePack',
  subtitle_standard: 'minuteProfessionPack',
  subtitle_premium: 'minuteEnjoyPack',
  subtitle_deluxe: 'minuteDeluxePack',
  subtitle_business_discovery: 'minuteDiscoveryPackBusiness',
  subtitle_business_essential: 'minuteEssentialPackBusiness',
  subtitle_business_professional: 'minuteProfessionalPackBusiness',
  subtitle_business_premium: 'minutePremiumPackBusiness',
  subtitle_trail: 'modePayment.gift',
  subtitle_quota_invitation: 'modePayment.invite',
  subtitle_migration: 'modePayment.gift',
};

// 支付方式映射
export const productPaymentMap: Record<string, string> = {
  QUOTA: 'modePayment.gift',
  PURCHASE: 'modePayment.recharge',
};

// 计划数据
export const plans: Plan[] = [
  // Personal Plans
  {
    id: 'personal-trial',
    name: 'Trial',
    price: 9.9,
    hours: '5.0',
    features: ['5 hours per month', 'All Personal features included'],
    category: 'personal'
  },
  {
    id: 'personal-professional',
    name: 'Professional',
    price: 19.9,
    hours: '15.0',
    features: ['15 hours per month', 'All Personal features included'],
    category: 'personal'
  },
  {
    id: 'personal-premium',
    name: 'Premium',
    price: 39.9,
    hours: '30.0',
    features: ['30 hours per month', 'All Personal features included'],
    category: 'personal'
  },
  {
    id: 'personal-premium-plus',
    name: 'Premium Plus',
    price: 99.9,
    hours: 'Unlimited',
    features: ['Unlimited hours', 'All Personal features included'],
    category: 'personal'
  },
  // Business Plans
  {
    id: 'business-trial',
    name: 'Trial',
    price: 19.9,
    hours: '5.0',
    features: ['5 hours per month', 'Enterprise features included'],
    category: 'business'
  },
  {
    id: 'business-professional',
    name: 'Professional',
    price: 39.9,
    hours: '15.0',
    features: ['15 hours per month', 'Enterprise features included'],
    category: 'business'
  },
  {
    id: 'business-premium',
    name: 'Premium',
    price: 79.9,
    hours: '30.0',
    features: ['30 hours per month', 'Enterprise features included'],
    category: 'business'
  },
  {
    id: 'business-premium-plus',
    name: 'Premium Plus',
    price: 199.9,
    hours: '80.0',
    features: ['80 hours per month', 'Enterprise features included'],
    category: 'business'
  }
];

// 附加包数据
export const addonPackages: AddonPackage[] = [
  {
    id: 'addon-1',
    name: 'Top-up Package 1',
    hours: '1.7',
    price: 9.9,
    description: 'Extra 1.7 hours when monthly quota is insufficient'
  },
  {
    id: 'addon-2', 
    name: 'Top-up Package 2',
    hours: '6.7',
    price: 39.0,
    description: 'Extra 6.7 hours when monthly quota is insufficient'
  },
  {
    id: 'addon-3',
    name: 'Top-up Package 3', 
    hours: '13.3',
    price: 59.0,
    description: 'Extra 13.3 hours when monthly quota is insufficient'
  },
  {
    id: 'addon-4',
    name: 'Top-up Package 4', 
    hours: '26.7', 
    price: 99.0,
    description: 'Extra 26.7 hours when monthly quota is insufficient'
  }
];

// 模拟支付方式数据
export const mockPaymentMethods: PaymentMethod[] = [
  {
    id: 'pm_1',
    type: 'card',
    last4: '4242',
    brand: 'Visa',
    expiryDate: '12/26',
    isDefault: true
  }
];

// 模拟发票数据
export const mockInvoices: Invoice[] = [
  {
    id: 'inv_001',
    date: '2024-01-15',
    amount: 29.99,
    status: 'paid',
    description: 'Pro Plan - Monthly',
    downloadUrl: '#'
  }
];